module.exports = __webpack_public_path__ + "static/img/peitu4-2.86cb6e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/purchaseCoordination/peitu4-2.png
// module id = 598
// module chunks = 12